// Мострите на легендите в „Резервации" (под схемата) и в „Таблица на
// резервациите" — едни и същи за общите статуси. Повтарят плотовете от
// tableTones.ts; лентите на таблицата са в същите цветове (table/scheduleTones.ts).
const SWATCH = "size-4 shrink-0 rounded-[4px]";

export const LEGEND_SWATCH = {
  free: `${SWATCH} border-[1.5px] border-schema-table-edge bg-surface`,
  reserved: `${SWATCH} border-2 border-dashed border-schema-reserved-edge-soft bg-schema-reserved`,
  occupied: `${SWATCH} border-[1.5px] border-schema-occupied-edge bg-schema-occupied`,
  fits: `${SWATCH} border-2 border-schema-fits-edge bg-surface`,
  selected: `${SWATCH} border-2 border-brand bg-brand-tint`,
  blocked: `${SWATCH} border-[1.5px] border-schema-blocked-edge bg-[repeating-linear-gradient(135deg,var(--color-schema-blocked)_0_3px,var(--color-schema-blocked-stripe)_3px_6px)]`,
  // Само в таблицата: „Неизпълнена" и „Приключила".
  expired: `${SWATCH} border-[1.5px] border-reservation-expired-edge bg-fill`,
  completed: `${SWATCH} border-[1.5px] border-shade-4 bg-fill`,
} as const;

export type LegendSwatch = keyof typeof LEGEND_SWATCH;
